import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import { GatewayService } from 'src/app/gateway.service';
import { switchMap, debounceTime, tap, finalize } from 'rxjs/operators';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ComponentTabController } from 'src/app/tab-controller';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { UploadServiceService } from 'src/app/services/upload-service.service';
import { ConfirmacionComponent } from '../../confirmacion/confirmacion.component';

@Component({
  selector: 'app-dlg-campana',
  templateUrl: './dlg-campana.component.html',
  styleUrls: ['./dlg-campana.component.scss']
})
export class DlgCampanaComponent implements OnInit {

  previewColumns = ['ID', 'NOMBRECLIENTE', 'TELEFONO', 'CODCLIENTE', 'SEGMENTO', 'RANGOMORA', 'ACCION'];
  dataSource = [];
  cantidadtotalarchivo: number = 0;
  isLoadingEje: boolean = false;
  filteredOptions: Observable<string[]>;
  file; valor; script; file2; valor2;
  minDate = new Date();
  resultsLength: number = 0;
  pageSize = 5;
  table = [];
  campanas = [];
  filterLista = null;
  estados: any = [
    { ID: 1, DESCRIPCION: 'Activo' },
    { ID: 2, DESCRIPCION: 'Inactivo' },
  ];

  medios: any = [
    //{ ID: 1, NOMBRE: 'SMS' },
    { ID: 2, NOMBRE: 'TMK' },
    //{ ID: 3, NOMBRE: 'APP' },
  ];

  tipclis: any = [
    { ID: 1, NOMBRE: 'Móvil' },
    { ID: 2, NOMBRE: 'Fijo' }
  ];

  tipcargas: any = [
    { NOMBRE: 'Leads', ID: 1 },
    { NOMBRE: 'Existentes', ID: 2 },
    { NOMBRE: 'De Baja', ID: 3 }
  ]

  tipos: any = [
    { nombre: 'Postventa', value: 0 },
    { nombre: 'Backoffice', value: 1 },
    { nombre: 'N/A', value: 2 }
  ]

  public isLoadingAgente: boolean = false;
  public filteredOptionsAgente: Observable<string[]>;
  public agentesarray: any = [];
  public agenteduplicada: boolean = false;

  grupoVal = new FormGroup({
    eje: new FormControl('', Validators.required),
    nombre: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    estado: new FormControl('', Validators.required),
    medio: new FormControl('', Validators.required),
    script: new FormControl(''),
    scripturl: new FormControl(''),
    fechaini: new FormControl('', Validators.required),
    fechafin: new FormControl('', Validators.required),
    contacto: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
    conversion: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
    efectividad: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
    llamadas: new FormControl(0, [Validators.min(0), Validators.required]),
    llamadascep: new FormControl(0, [Validators.min(0), Validators.required]),
    tmo: new FormControl(0, [Validators.min(0), Validators.required]),
    tipoalta: new FormControl(0, Validators.required),
    tipcli: new FormControl(0, Validators.required),
    tipcarga: new FormControl(0, Validators.required)
  });

  grupoVal1 = new FormGroup({
    agente: new FormControl('', Validators.required),
    porcontacto: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
    porefectivo: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
    porconvertido: new FormControl(0, [Validators.min(0), Validators.max(100), Validators.required]),
    llamadas: new FormControl(0, [Validators.min(0), Validators.required]),
    llamadascep: new FormControl(0, [Validators.min(0), Validators.required]),
    tmoa: new FormControl(0, [Validators.min(0), Validators.required])
  });

  @ViewChild('listaPaginator') listaPaginator: MatPaginator;

  constructor(
    public gateway: GatewayService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DlgCampanaComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    public localSave: LocalSaveService,
    public tabController: ComponentTabController,
    private spinner: NgxSpinnerService,
    private uploadService: UploadServiceService

  ) { }

  ngOnInit() {
    // console.log(this.data);
    this.minDate = this.data.vigenciainicial;
    this.localSave.set('campana', this.data.idcampana);
    this.tabController.index = 0;
    this.grupoVal.controls['scripturl'].disable();

    ////////////////////////////////-------------EJE--------------\\\\\\\\\\\\\\\\\\\\\\\\\\\\
    this.loadEje();
    this.loadAgentesTable();
    this.getCampanas();
    this.grupoVal
      .get('eje')
      .valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.isLoadingEje = true),
        switchMap(value =>
          this.gateway.get('geteje', { NUM_PAGINA: 0, FILTRO: null, NUM_ELEMENTOS: 5, IDPAIS: null, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA })
            .then((result: any) => {
              // console.log(result.rows);
              this.filteredOptions = result.rows;
              this.isLoadingEje = false;
            }
            ).catch(function (e) {
            })
        )
      )
      .subscribe(eje => {
      }
      );

    this.grupoVal1
      .get('agente')
      .valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.isLoadingAgente = true),
        switchMap(value =>
          this.gateway.get('getagenteagente', { NUM_PAGINA: 0, FILTRO: value, NUM_ELEMENTOS: 5, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA })
            .then((result: any) => {
              this.filteredOptionsAgente = result.rows;
              this.isLoadingAgente = false;
            }
            ).catch(function (e) {
            })
        )
      )
      .subscribe(campana => {
      }
      );

    ////////////////////////////////-------------EJE--------------\\\\\\\\\\\\\\\\\\\\\\\\\\\\

    // LOAD DATA
    // console.log(this.data);
    this.grupoVal.controls.eje.setValue({ ideje: this.data.ideje, nombre: this.data.nombreeje, color: this.data.color, idpais: this.data.idpais });
    this.grupoVal.controls.nombre.setValue(this.data.nombre);
    this.grupoVal.controls.estado.setValue(this.data.estado);
    this.grupoVal.controls.medio.setValue(this.data.medio);
    this.grupoVal.controls.script.setValue(this.data.script);
    this.grupoVal.controls.scripturl.setValue(this.data.scripturl);
    this.grupoVal.controls.fechafin.setValue(new Date(this.data.vigenciafinal));
    this.grupoVal.controls.fechaini.setValue(new Date(this.data.vigenciainicial));

    this.grupoVal.controls.contacto.setValue(this.data.contacto);
    this.grupoVal.controls.conversion.setValue(this.data.conversion);
    this.grupoVal.controls.efectividad.setValue(this.data.efectividad);
    this.grupoVal.controls.tmo.setValue(this.data.tmo);
    this.grupoVal.controls.tipoalta.setValue(this.data.tipoalta);
    this.grupoVal.controls.llamadas.setValue(this.data.llamadas);
    this.grupoVal.controls.llamadascep.setValue(this.data.llamadascep);
    this.grupoVal.controls.tipcli.setValue(this.data.tip_cliente);
    this.grupoVal.controls.tipcarga.setValue(this.data.tip_carga);

    // this.localSave.set('campana_contacto', this.data.contacto);
    // this.localSave.set('campana_conversion', this.data.conversion);
    // this.localSave.set('campana_efectividad', this.data.efectividad);
    // this.localSave.set('campana_tmo', this.data.tmo);

    this.grupoVal1.controls.porcontacto.setValue(this.grupoVal.controls.contacto.value);
    this.grupoVal1.controls.porefectivo.setValue(this.grupoVal.controls.conversion.value);
    this.grupoVal1.controls.porconvertido.setValue(this.grupoVal.controls.efectividad.value);
    this.grupoVal1.controls.tmoa.setValue(this.grupoVal.controls.tmo.value);
    this.grupoVal1.controls.llamadas.setValue(this.grupoVal.controls.llamadas.value);
    this.grupoVal1.controls.llamadascep.setValue(this.grupoVal.controls.llamadascep.value);

    // END LOAD DATA
  }

  tabChanged(event) {
    if (event.index == 6) {
      this.spinner.show();
      this.listaPaginator.firstPage();
      /////////////////////////////////// PREVLIST
      this.gateway.get('prevlista', { IDCAMPANA: this.data.idcampana, FILTRO: null, PAGINA: 0 })
        .then((result: any) => {
          this.dataSource = result.CLIENTES;
          this.cantidadtotalarchivo = result.CANTIDAD;
          this.resultsLength = result.CANTIDAD;
          // console.log(result);
          this.spinner.hide();
        }
        ).catch(function (e) {
          this.spinner.hide();
        })
      /////////////////////////////////// PREVLIST
    }
  }

  modify() {
    this.spinner.show();
    if (this.grupoVal.controls.eje.value.ideje) {

      // this.localSave.set('campana_contacto', this.grupoVal.controls.contacto.value);
      // this.localSave.set('campana_conversion', this.grupoVal.controls.conversion.value);
      // this.localSave.set('campana_efectividad', this.grupoVal.controls.efectividad.value);
      // this.localSave.set('campana_tmo', this.grupoVal.controls.tmo.value);

      this.grupoVal1.controls.porcontacto.setValue(this.grupoVal.controls.contacto.value);
      this.grupoVal1.controls.porefectivo.setValue(this.grupoVal.controls.conversion.value);
      this.grupoVal1.controls.porconvertido.setValue(this.grupoVal.controls.efectividad.value);
      this.grupoVal1.controls.tmoa.setValue(this.grupoVal.controls.tmo.value);
      this.grupoVal1.controls.llamadas.setValue(this.grupoVal.controls.llamadas.value);
      this.grupoVal1.controls.llamadascep.setValue(this.grupoVal.controls.llamadascep.value);

      if (typeof (this.script) == "undefined") {
        let CAMPANA = {
          IDCAMPANA: this.data.idcampana,
          IDEJE: this.grupoVal.controls.eje.value.ideje,
          NOMBRE: this.grupoVal.controls.nombre.value,
          ESTADO: this.grupoVal.controls.estado.value,
          MEDIO: this.grupoVal.controls.medio.value,
          VIGENCIAINICIAL: this.grupoVal.controls.fechaini.value,
          VIGENCIAFINAL: this.grupoVal.controls.fechafin.value,
          SCRIPT: this.grupoVal.controls.script.value,
          SCRIPTURL: '',
          CONTACTO: String(this.grupoVal.controls.contacto.value).length == 0 ? 0 : this.grupoVal.controls.contacto.value,
          CONVERSION: String(this.grupoVal.controls.conversion.value).length == 0 ? 0 : this.grupoVal.controls.conversion.value,
          EFECTIVIDAD: String(this.grupoVal.controls.efectividad.value).length == 0 ? 0 : this.grupoVal.controls.efectividad.value,
          TMO: String(this.grupoVal.controls.tmo.value).length == 0 ? 0 : this.grupoVal.controls.tmo.value,
          TIPOALTA: this.grupoVal.controls.tipoalta.value,
          LLAMADAS: this.grupoVal.controls.llamadas.value,
          LLAMADASCEP: this.grupoVal.controls.llamadascep.value,
          TIPOCLIENTE: this.grupoVal.controls.tipcli.value,
          TIPOCARGA: this.localSave.get('usuarioPGV').TIPO == 1 ? this.grupoVal.controls.tipcarga.value : 1
        }

        this.gateway.get('modifyCampana', CAMPANA).then((result) => {
          // this.dialogRef.close();
          this.tabController.index = 1;
          this.spinner.hide();
          // Luego de guardar debo generar la lista si es externa
          // de ser interna entonces se genera hasta asignar los criterios
        }).catch(function (e) { });
      }
      else {
        this.uploadService.uploadfile(this.script).then(
          data => {
            let CAMPANA = {
              IDCAMPANA: this.data.idcampana,
              IDEJE: this.grupoVal.controls.eje.value.ideje,
              NOMBRE: this.grupoVal.controls.nombre.value,
              ESTADO: this.grupoVal.controls.estado.value,
              MEDIO: this.grupoVal.controls.medio.value,
              VIGENCIAINICIAL: this.grupoVal.controls.fechaini.value,
              VIGENCIAFINAL: this.grupoVal.controls.fechafin.value,
              SCRIPT: this.grupoVal.controls.script.value,
              SCRIPTURL: data['Location'],
              CONTACTO: this.grupoVal.controls.contacto.value,
              CONVERSION: this.grupoVal.controls.conversion.value,
              EFECTIVIDAD: this.grupoVal.controls.efectividad.value,
              TMO: this.grupoVal.controls.tmo.value,
              TIPOALTA: this.grupoVal.controls.tipoalta.value,
              LLAMADAS: this.grupoVal.controls.llamadas.value,
              LLAMADASCEP: this.grupoVal.controls.llamadascep.value,
              TIPOCLIENTE: this.grupoVal.controls.tipcli.value,
              TIPOCARGA: this.localSave.get('usuarioPGV').TIPO == 1 ? this.grupoVal.controls.tipcarga.value : 1
            }

            this.gateway.get('modifyCampana', CAMPANA).then((result) => {
              // this.dialogRef.close();
              //this.localSave.set('campana', result[0][0].ID);
              this.tabController.index = 1;
              this.spinner.hide();
              // Luego de guardar debo generar la lista si es externa
              // de ser interna entonces se genera hasta asignar los criterios

            }
            ).catch(function (e) {
            });
          }
        );
      }
    }
    else {
      this.spinner.hide();
      this.snackbar.open('Eje invalido.', 'Cerrar', { duration: 3000, });
      this.grupoVal.patchValue({
        eje: ''
      })
    }

  }

  loadEje() {
    this.gateway.get('geteje', { NUM_PAGINA: 0, FILTRO: null, NUM_ELEMENTOS: 5, IDPAIS: null, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result: any) => {
      // console.log(result.rows);
      this.filteredOptions = result.rows;
    }
    ).catch(function (e) {
    });
  }

  displayFn(eje?: any): string | undefined {
    if (eje) { return eje.nombre }
  }

  onNoClick() {
    this.localSave.delete('campana');
    this.dialogRef.close(false);
  }

  noAutorizar() {
    const dialogRef = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '300px',
      data: { sms: 'No Autorizar la campaña', addcomment: true }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.resp) {
        this.gateway.get('setautorizacioncamp', {
          IDCAMPANA: this.data.idcampana,
          AUTORIZACION: -1,
          COMENTARIO: result.comentario
        }).then(result => {
          this.snackbar.open('Campaña No Autorizada correctamente.', 'Cerrar', { duration: 3000, });
          this.localSave.delete('campana');
          this.dialogRef.close(true);
        });
      }
    });
  }

  autorizar() {
    const dialogRef = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '300px',
      data: { sms: 'Autorizar la campaña', addcomment: false }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.resp) {
        this.gateway.get('setautorizacioncamp', {
          IDCAMPANA: this.data.idcampana,
          AUTORIZACION: 1
        }).then(result => {
          this.snackbar.open('Campaña Autorizada correctamente.', 'Cerrar', { duration: 3000, });
          this.localSave.delete('campana');
          this.dialogRef.close(true);
        });
      }
    });
  }

  listaclsoe() {
    this.localSave.delete('campana');
    this.dialogRef.close(true);
  }

  getError(type) {
    if (type == 1) {
      if (this.grupoVal.controls.eje.hasError('required')) {
        return 'Debes seleccionar un Eje';
      }
    }
    else if (type == 2) {
      if (this.grupoVal.controls.nombre.hasError('required')) {
        return 'Debes ingresar un Nombre';
      }
    }
    else if (type == 3) {
      if (this.grupoVal.controls.estado.hasError('required')) {
        return 'Debes seleccionar una Estado';
      }
    }
    else if (type == 4) {
      if (this.grupoVal.controls.medio.hasError('required')) {
        return 'Debes seleccionar un Medio';
      }
    }
    else if (type == 5) {
      if (this.grupoVal.controls.scripturl.hasError('required')) {
        return 'Debes ingresar un Script';
      }
    }
    else if (type == 6) {
      if (this.grupoVal.controls.fechaini.hasError('required')) {
        return 'Debes seleccionar una Fecha Inicial Válida';
      }
    }
    else if (type == 7) {
      if (this.grupoVal.controls.fechafin.hasError('required')) {
        return 'Debes seleccionar una Fecha Final Válida';
      }
    }
    else if (type == 8) {
      return 'Debes ingresar un porcentaje entre 0 y 100';
    }
    else if (type == 9) {
      return 'Debes ingresar un un valor numérico';
    }
    else if (type == 10) {
      if (this.grupoVal1.controls.agente.hasError('required')) {
        return 'Debes seleccionar un agente';
      }
    }
    else if (type == 11) {
      if (this.grupoVal1.controls.porcontacto.hasError('required')) {
        return 'Debes ingresar un porcentaje contacto';
      } else if (this.grupoVal1.controls.porcontacto.hasError('min') || this.grupoVal1.controls.porcontacto.hasError('max')) {
        return 'Debes ingresar un porcentaje entre 0 y 100';
      }
    }
    else if (type == 12) {
      if (this.grupoVal1.controls.porefectivo.hasError('required')) {
        return 'Debes ingresar un porcentaje efectividad';
      } else if (this.grupoVal1.controls.porefectivo.hasError('min') || this.grupoVal1.controls.porefectivo.hasError('max')) {
        return 'Debes ingresar un porcentaje entre 0 y 100';
      }
    }
    else if (type == 13) {
      if (this.grupoVal1.controls.porconvertido.hasError('required')) {
        return 'Debes ingresar un porcentaje conversión';
      } else if (this.grupoVal1.controls.porconvertido.hasError('min') || this.grupoVal1.controls.porconvertido.hasError('max')) {
        return 'Debes ingresar un porcentaje entre 0 y 100';
      }
    }
    else if (type == 14) {
      if (this.grupoVal1.controls.tmoa.hasError('required')) {
        return 'Debes ingresar un TMO en segundos';
      } else if (this.grupoVal1.controls.tmoa.hasError('min') || this.grupoVal1.controls.porconvertido.hasError('max')) {
        return 'Debes ingresar un TMO mayor de 1 segundo';
      }
    }
    else if (type == 15) {
      if (this.grupoVal.controls.tipoalta.hasError('required')) {
        return 'Debes seleccionar Tipo alta';
      }
    }

  }

  openInput() {
    document.getElementById("fileInput").click();
  }

  openInputDelete() {
    document.getElementById("fileInputDelete").click();
  }

  ObtenerArchivoCarga(event) {

    this.file = event.target.files[0];
    this.valor = this.file.name;
    if (typeof (this.file != "undefined")) {
      this.cargarLista();
    }
  }

  ObtenerArchivoDelete(event) {

    this.file = event.target.files[0];
    this.valor = this.file.name;
    if (typeof (this.file != "undefined")) {
      //this.cargarLista();
      this.cargarListaDelete();
    }
  }

  openInput2() {
    document.getElementById("fileInput2").click();
  }

  ObtenerArchivoCarga2(event) {

    this.file2 = event.target.files[0];
    this.valor2 = this.file2.name;
  }

  CargarScript(event) {
    this.script = event.target.files[0];
    // if (this.script) {
    // 	if (this.script.type.toLowerCase() == 'application/pdf') {
    // 		//console.log(this.script);
    // 		this.grupoVal.controls['scripturl'].setValue(this.script.name)
    // 	} else {
    // 		this.script = undefined;
    // 		this.grupoVal.controls['scripturl'].setValue('')
    // 		this.snackbar.open('Solo se permiten archivos PDF.', 'Cerrar', { duration: 3000, });
    // 	}
    // }

    if (this.script) {
      // console.log('----this.script.type---')
      // console.log(this.script)
      // console.log('----//this.script.type---')
      // if (this.script.type.toLowerCase() == 'application/pdf') {
      //console.log(this.script);
      this.grupoVal.controls['scripturl'].setValue(this.script.name)
      // } else {
      // 	this.script = undefined;
      // 	this.grupoVal.controls['scripturl'].setValue('')
      // 	this.snackbar.open('Solo se permiten archivos PDF.', 'Cerrar', { duration: 3000, });
      // }
    }
  }

  cargarLista() {
    this.spinner.show();
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
      (<HTMLInputElement>document.getElementById('fileInput')).value = null;

      this.loadlistxls(dataexcel);
      // this.dialogRef.close({dataexcel:dataexcel,pais:this.PAIS,type:1});
    };
    reader.readAsBinaryString(this.file);

  }

  async loadlistxls(data) {

    let dataConvert: any = this.convertirArreglo(data);

    function sendLista(cantidad, gatew, idcampana, localspinner, localsnack, this2) {
      const that = this2;
      let auxarr = [];
      auxarr = dataConvert.slice(cantidad, cantidad + 100);
      // console.log('==========');
      // console.log(cantidad);
      // console.log(auxarr);
      // console.log('======//====');

      gatew.save('listaexistente', { CLIENTES: '', ARR_OBJ: auxarr, IDCAMPANA: idcampana }).then(
        res => {
          if ((cantidad + 100) < dataConvert.length) {
            sendLista(cantidad + 100, gatew, idcampana, localspinner, localsnack, this2)
          } else {
            localspinner.hide();
            localsnack.open('Clientes cargados con éxito.', 'Cerrar', { duration: 3000, });
            /////////////////////////////////// PREVLIST
            // gatew.get('prevlista', { IDCAMPANA: idcampana })
            // 	.then((result: any) => {
            // 		// console.log(result);
            // 		that.dataSource = result.CLIENTES;
            // 		that.cantidadtotalarchivo = result.CANTIDAD;
            // 	}
            // 	).catch(function (e) {
            // 	})

            gatew.get('prevlista', { IDCAMPANA: idcampana, FILTRO: null, PAGINA: 0 })
              .then((result: any) => {
                that.dataSource = result.CLIENTES;
                that.cantidadtotalarchivo = result.CANTIDAD;
                that.resultsLength = result.CANTIDAD;
                // console.log(result);
              }
              ).catch(function (e) {
              })
            /////////////////////////////////// PREVLIST
          }
        },

        err => {
          localsnack.open('Los clientes no han sido cargados, intente nuevamente.', 'Cerrar', { duration: 3000, });
          localspinner.hide();
          // console.log(err);
        }
      );

    }

    // console.log('======dataexcel====');
    // console.log(dataConvert);
    // console.log('======//dataexcel====');
    dataConvert = await this.filtrarClientes(dataConvert);
    // console.log('==filtrado dataexcel=');
    // console.log(dataConvert);
    // console.log('======//dataexcel====');
    sendLista(0, this.gateway, this.localSave.get('campana'), this.spinner, this.snackbar, this);

  }

  filtrarClientes(dataClient = []) {
    // 1. Insertar los datos en una tabla temporal
    // 2. Corroborar que no hayan clientes duplicados y devolver clientes no repetidos
    // 3. seguir con el proceso sendLista

    return new Promise((resolve, reject) => {
      this.gateway.get('filtrarclicamp', {
        IDCAMPANA: this.localSave.get('campana'),
        USUARIO: this.localSave.get('usuarioPGV'),
        CLIENTES: dataClient
      }).then(
        (data: any) => {
          if (data.rows.length > 0) {
            resolve(data.rows);
          } else {
            this.snackbar.open('No hay clientes para esta campaña.', 'Cerrar', { duration: 3000, });
            // this.spinner.hide();
            resolve([]);
          }
        }
      );
    });
  }

  convertirArreglo(data) {
    let keys = data.splice(0, 1)[0];
    // console.log(keys);
    let ret = [];
    try {
      data.forEach(element => {
        const obj: any = {};
        for (let index = 0; index < element.length; index++) {
          let aux: string = keys[index];
          aux = aux.replace('"', '').trim();
          obj[aux] = element[index];
        }
        if (obj.ID || obj.id) {
          ret.push(obj);
        }
      });
      return ret;
    } catch (e) {
      this.spinner.hide();
      this.snackbar.open('Archivo no válido intente de nuevo.', 'Cerrar', { duration: 3000, });
      return ret;
    }
  }

  exportar() {
    this.spinner.show();
    this.gateway.get('exportarlistacount', { IDCAMPANA: this.localSave.get('campana') }).then(
      (data: any) => {
        if (data.rows[0].cantidad > 0) {
          this.prepararinformacion(this.localSave.get('campana'), data.rows[0].cantidad, 0, null);
        } else {
          this.snackbar.open('No hay clientes para esta campaña.', 'Cerrar', { duration: 3000, });
          this.spinner.hide();
        }
      }
    );
  }

  prepararinformacion(campana, count, index, data) {
    // console.log({ IDCAMPANA: campana, LIMIT: 100, OFFSET: index })
    // console.log('==========')
    this.gateway.get('exportarlistalote', { IDCAMPANA: campana, LIMIT: 100, OFFSET: index }).then(
      (result: any) => {
        if (data) {
          data = data.concat(result.rows)
        } else {
          data = result.rows;
        }
        // console.log('==========')
        // console.log(data)
        // console.log('==========')
        let control = index + 100;
        if (control <= count) {
          // console.log('==========')
          // console.log(control)
          // console.log('==========')
          this.prepararinformacion(campana, count, control, data);
        } else {
          this.descargarexcel(data, campana);
        }
      }
    );
  }

  descargarexcel(ctr, campana) {
    const fileName = 'Campana' + campana + '-' + Date.now();
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ctr);
    XLSX.utils.book_append_sheet(wb, ws);

    const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
    this.spinner.hide();
  }

  openInputScript() {
    document.getElementById("fileInputScript").click();
  }

  public displayFnAgente(agente?: any): string | undefined {
    if (agente) { return agente.nombre }
  }

  public loadAgentesTable() {
    this.gateway.get('agentecampanalite', { IDCAMPANA: this.data.idcampana }).then((result: any) => {
      // console.log(result);
      this.agentesarray = result.rows;
    }
    ).catch(function (e) {
    });
  }

  public loadAgentes() {
    this.gateway.get('getagenteagente', { NUM_PAGINA: 0, FILTRO: null, NUM_ELEMENTOS: 5, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result: any) => {
      // console.log(result);
      this.filteredOptionsAgente = result.rows;
    }
    ).catch(function (e) {
    });
  }

  public agregaragente() {
    this.agenteduplicada = false;

    if (this.grupoVal1.controls.agente.value.idagente) {
      let exist = this.agentesarray.map((e) => {
        return e.idagente;
      }).indexOf(this.grupoVal1.controls.agente.value.idagente);

      if (exist == -1) {
        this.spinner.show();
        this.gateway.get('campanasagente', { IDAGENTE: this.grupoVal1.controls.agente.value.idagente }).then((result) => {
          let aux: any = result;
          this.table = aux.rows;
          if (this.table.length > 0) {
            this.table.forEach(element => {
              element.campana = this.campanas.find((mini) => {
                return mini.idcampana == element.idcampana;
              })
            });
            this.gateway.save('validatraslapecampana', { CAMPANAS: this.table, NUEVA: { campana: { idcampana: this.data.idcampana } } }).then((result: any) => {
              // if (result.validacion == 0) {
              this.spinner.hide();
              this.agentesarray.push({ idagente: this.grupoVal1.controls.agente.value.idagente, contacto: this.grupoVal1.controls.porcontacto.value, efectividad: this.grupoVal1.controls.porefectivo.value, conversion: this.grupoVal1.controls.porconvertido.value, nombre: this.grupoVal1.controls.agente.value.nombre, apellido: this.grupoVal1.controls.agente.value.apellido, correo: this.grupoVal1.controls.agente.value.correo, tmo: this.grupoVal1.controls.tmoa.value, llamadas: this.grupoVal1.controls.llamadas.value, llamadascep: this.grupoVal1.controls.llamadascep.value });
              this.grupoVal1.controls.agente.setValue('');
              this.grupoVal1.controls.porcontacto.setValue(this.grupoVal.controls.contacto.value);
              this.grupoVal1.controls.porefectivo.setValue(this.grupoVal.controls.conversion.value);
              this.grupoVal1.controls.porconvertido.setValue(this.grupoVal.controls.efectividad.value);
              this.grupoVal1.controls.tmoa.setValue(this.grupoVal.controls.tmo.value);
              this.grupoVal1.controls.llamadas.setValue(this.grupoVal.controls.llamadas.value);
              this.grupoVal1.controls.llamadascep.setValue(this.grupoVal.controls.llamadascep.value);
              this.grupoVal1.controls.agente.reset();
              // } else {
              //   this.spinner.hide();
              //   this.snackbar.open('No puedes agregar al agente debido a traslape de horario con otras campañas.', 'Cerrar', {
              //     duration: 5000,
              //   });
              // }

            })
          } else {
            this.spinner.hide();
            this.agentesarray.push({ idagente: this.grupoVal1.controls.agente.value.idagente, contacto: this.grupoVal1.controls.porcontacto.value, efectividad: this.grupoVal1.controls.porefectivo.value, conversion: this.grupoVal1.controls.porconvertido.value, nombre: this.grupoVal1.controls.agente.value.nombre, apellido: this.grupoVal1.controls.agente.value.apellido, correo: this.grupoVal1.controls.agente.value.correo, tmo: this.grupoVal1.controls.tmoa.value, llamadas: this.grupoVal1.controls.llamadas.value, llamadascep: this.grupoVal1.controls.llamadascep.value });
            this.grupoVal1.controls.agente.setValue('');
            this.grupoVal1.controls.porcontacto.setValue(this.grupoVal.controls.contacto.value);
            this.grupoVal1.controls.porefectivo.setValue(this.grupoVal.controls.conversion.value);
            this.grupoVal1.controls.porconvertido.setValue(this.grupoVal.controls.efectividad.value);
            this.grupoVal1.controls.tmoa.setValue(this.grupoVal.controls.tmo.value);
            this.grupoVal1.controls.llamadas.setValue(this.grupoVal.controls.llamadas.value);
            this.grupoVal1.controls.llamadascpe.setValue(this.grupoVal.controls.llamadascpe.value);
            this.grupoVal1.controls.agente.reset();
          }

        }
        ).catch(function (e) { });

      } else {
        this.agenteduplicada = true;
        this.snackbar.open('Agente ya se encuentra en la lista', 'CERRAR', { duration: 3000 });
      }
    } else {
      this.grupoVal1.controls.agente.setValue('');
      this.grupoVal1.controls.agente.reset();
      this.snackbar.open('Debe seleccionar un agente válido.', 'CERRAR', { duration: 3000 });
    }
  }

  public remove(index): void {
    this.agentesarray.splice(index, 1);
  }

  public saveAgentes() {
    this.spinner.show();
    this.gateway.get('asignaragente', { IDCAMPANA: this.data.idcampana, LISTA: this.agentesarray }).then((result: any) => {
      this.spinner.hide();
      // console.log(result);
      this.tabController.index = 5;
      this.grupoVal1.controls.agente.setValue('');
      // this.grupoVal1.controls.porcontacto.setValue(0);
      // this.grupoVal1.controls.porefectivo.setValue(0);
      // this.grupoVal1.controls.porconvertido.setValue(0);
      // this.grupoVal1.controls.tmoa.setValue(0);
      this.grupoVal1.controls.agente.reset();
      // this.grupoVal1.controls.porcontacto.reset();
      // this.grupoVal1.controls.porefectivo.reset();
      // this.grupoVal1.controls.porconvertido.reset();
      // this.grupoVal1.controls.tmoa.reset();
      // this.filteredOptionsAgente = result.rows;
      this.grupoVal1.controls.porcontacto.setValue(this.grupoVal.controls.contacto.value);
      this.grupoVal1.controls.porefectivo.setValue(this.grupoVal.controls.conversion.value);
      this.grupoVal1.controls.porconvertido.setValue(this.grupoVal.controls.efectividad.value);
      this.grupoVal1.controls.tmoa.setValue(this.grupoVal.controls.tmo.value);
      this.grupoVal1.controls.llamadas.setValue(this.grupoVal.controls.llamadas.value);
      this.grupoVal1.controls.llamadascpe.setValue(this.grupoVal.controls.llamadascpe.value);
    }
    ).catch(function (e) {
    });
  }

  cargarListaDelete() {
    this.spinner.show();
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
      (<HTMLInputElement>document.getElementById('fileInputDelete')).value = null;

      this.loadlistxlsDelete(dataexcel);
      // this.dialogRef.close({dataexcel:dataexcel,pais:this.PAIS,type:1});
      //console.log(dataexcel);
      //this.spinner.hide();
    };
    reader.readAsBinaryString(this.file);

  }

  loadlistxlsDelete(data) {

    //console.log(data);
    const dataConvert = this.convertirArreglo(data);
    //console.log(dataConvert);

    function sendLista(cantidad, gatew, idcampana, localspinner, localsnack, this2) {
      const that = this2;
      let auxarr = [];
      auxarr = dataConvert.slice(cantidad, cantidad + 100);
      gatew.save('desasignarlista', { CLIENTES: '', ARR_OBJ: auxarr, IDCAMPANA: idcampana }).then(
        res => {
          if ((cantidad + 100) < dataConvert.length) {
            sendLista(cantidad + 100, gatew, idcampana, localspinner, localsnack, this2)
          } else {
            localspinner.hide();
            localsnack.open('Clientes eliminados con éxito.', 'Cerrar', { duration: 3000, });
            /////////////////////////////////// PREVLIST
            gatew.get('prevlista', { IDCAMPANA: idcampana, FILTRO: null, PAGINA: 0 })
              .then((result: any) => {
                that.dataSource = result.CLIENTES;
                that.cantidadtotalarchivo = result.CANTIDAD;
                that.resultsLength = result.CANTIDAD;
                // console.log(result);
              }
              ).catch(function (e) {
              })
            /////////////////////////////////// PREVLIST
          }
        },

        err => {
          localsnack.open('Los clientes no han sido eliminados, intente nuevamente.', 'Cerrar', { duration: 3000, });
          localspinner.hide();
          // console.log(err);
        }
      );

    }
    if (dataConvert.length > 0) {
      sendLista(0, this.gateway, this.localSave.get('campana'), this.spinner, this.snackbar, this);
    }
  }

  getCampanas() {
    this.gateway.get('listacampanas', { NUM_PAGINA: 0, FILTRO: null, NUM_ELEMENTOS: 5, IDPAIS: 5 }).then((result) => {
      let aux: any = result;
      this.campanas = aux.rows;
      //this.getLista();
    }
    ).catch(function (e) {
    });
  }

  keyDownFunctionCampana(event) {
    if (event.keyCode == 13) {
      this.filtrarLista(0);
    } else if (event.keyCode == 8 && this.filterLista == '') {
      this.filtrarLista(0);
    }
  }

  filtrarLista(page) {
    this.spinner.show();
    if (page == 0) {
      this.listaPaginator.firstPage();
    }

    let fil = null;
    if (this.filterLista != "" && this.filterLista != null) {
      fil = '%' + this.filterLista + '%';
    }

    this.gateway.get('prevlista', { IDCAMPANA: this.data.idcampana, FILTRO: fil, PAGINA: page })
      .then((result: any) => {
        this.dataSource = result.CLIENTES;
        this.cantidadtotalarchivo = result.CANTIDAD;
        this.resultsLength = result.CANTIDAD;
        this.spinner.hide();
        // console.log(result);
      }
      ).catch(function (e) {
        this.spinner.hide();
      })
  }

  cambioElementosLista(event?: PageEvent) {
    this.filtrarLista(event.pageIndex);
  }

}
